import React from "react";
import { Link, useParams } from "react-router-dom";
import blogsJson from "../../data/blogs.json";
import blogDetails from "../../data/blogDetails.json";
import BlogReccomendations from "../BlogReccomendations";
import styles from "./styles.module.css";
import { NavLink } from "react-router-dom";


const BlogDetailsCard = () => {
  const { handle } = useParams();
  const blog = blogsJson.find((b) => b.handle === handle);

  const blogDetail = blogDetails.find((b) => b.handle === blog.handle);
  // console.log("this is the detailed blog", blogDetail);

  return (
    <div
      className={`bg-[#FFFF] my-[30px] max-w-[95%] lg:max-w-[90%] md:max-w-[80%] px-[10px] h-auto m-auto ${styles.cardHolder} `}
    >
      <div className="relative group">
        <img
          className="w-full object-contain transition-opacity duration-300"
          src={blog.imgUrl}
          alt={blog.text}
        />

        <div className="absolute px-2 py-1 text-xs text-gray-400 bg-opacity-50 rounded backdrop-opacity-30 bottom-2 left-2 lg:bottom-10 lg:left-7">
          {blog.publishDate}
        </div>
      </div>

      {/* Published By (Clickable) */}
      {blog.author && (
        <p className="text-blue-600 text-center md:text-left mt-8 ml-5">
        {" "}
          <Link
            to={`/author/${blog.author.toLowerCase()}`}
            className="hover:underline hover:text-blue text text-xl"
          >
            Published by {blog.author}
          </Link>
        </p>
      )}

      <div className="px-2 py-2 lg:px-5 lg:py-5">
        <h1 className="mb-2 text-3xl lg:mb-4 lg:text-3xl">
          {blogDetail.title}
        </h1>
        <p className="mb-6 text-lg whitespace-pre-line" dangerouslySetInnerHTML={{ __html: blogDetail.introduction }}></p>

        {/* Sections */}
        <div className="space-y-6">
          {blogDetail.sections.map((section, index) => (
            <div key={index} className="pb-1 mb-1" style={{marginTop: 5}}>
              {/* Section Title */}
              {section.title && (
                <h2 className="mb-2 text-lg font-semibold text-gray-800">
                  {section.title}
                </h2>
              )}

              {section.primaryhead && (
                <h2 className="mb-2 text-[30px] font-bold text-black leading-[normal]">
                  {section.primaryhead}
                </h2>
              )}

              {section.h3 && (
                <h3 className="mb-2 text-[20px] font-bold text-black leading-[normal]">
                  {section.h3}
                </h3>
              )}

              {section.secondaryhead && (
                <h2 className="my-2 text-[24px] font-bold text-black leading-normal">
                  {section.secondaryhead}
                </h2>
              )}

              {/* Section Content */}
              {section.content && (
                <p className="mb-1 text-lg" dangerouslySetInnerHTML={{ __html: section.content }}></p>
              )}

              {section.htmlContent && (
                <p className="mb-1 text-lg" dangerouslySetInnerHTML={{ __html: section.htmlContent }}></p>
              )}

              {/* Features */}
              {section.features && (
                <div>
                  {/* Check if pros and cons exist */}
                  {section.features.pros || section.features.cons ? (
                    <>
                      {/* Pros */}
                      {section.features.pros && (
                        <div className="mb-2">
                          <h3 className="text-lg font-semibold text-gray-800">
                            Pros:
                          </h3>
                          <ul className="ml-6 list-disc">
                            {section.features.pros.map((pro, i) => (
                              <li
                                className="text-lg"
                                key={i}
                                dangerouslySetInnerHTML={{ __html: pro }}
                              />
                            ))}
                          </ul>

                        </div>
                      )}

                      {/* Cons */}
                      {section.features.cons && (
                        <div>
                          <h3 className="text-lg font-semibold text-gray-800">
                            Cons:
                          </h3>
                          <ul className="ml-6 list-disc">
                            {section.features.cons.map((con, i) => (
                              <li className="text-lg" key={i}>{con}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </>
                  ) : (
                    /* If no pros and cons but features array exists */
                    <ul className="ml-6 list-disc">
                      {section.features.map((feature, i) => (
                        <li
                          className="text-lg"
                          key={i}
                          dangerouslySetInnerHTML={{ __html: feature }}
                        />
                      ))}
                    </ul>

                  )}
                </div>
              )}

              {section.keypoints && (
                <div>

                  {section.keypoints.key_points ? (
                    <>

                      {section.keypoints.key_points && (
                        <div className="mb-2">
                          <h3 className="text-lg font-bold">
                            {section.keypoints.title}
                          </h3>
                          <ul className="ml-6 py-2 list-disc">
                            {section.keypoints.key_points.map((keypoints, i) => (
                              <li
                                className="text-lg"
                                key={i}
                                dangerouslySetInnerHTML={{ __html: keypoints }}
                              />
                            ))}
                          </ul>

                        </div>
                      )}
                    </>
                  ) : (
                    <ul className="ml-6 list-disc">
                      {section.keypoints.map((keypoints, i) => (
                        <li className="text-lg" key={i}>{keypoints}</li>
                      ))}
                    </ul>
                  )}
                </div>
              )}

              {section.imageSection && (
                <div className="my-4">
                  <img
                    src={section.imageSection.imageUrl}
                    alt={section.imageSection.altText}
                    className="w-full h-auto"
                  />
                </div>
              )}

              {section.bannerwithbutton && (
                <div className="my-4 bg-[#df1a2c] block w-100 p-[100px] rounded-2xl">
                  <p className="text-center text-white m-5 text-[18px]">
                    {section.bannerwithbutton.bannertext}
                  </p>
                  <NavLink
                    to={section.bannerwithbutton.bannerurl}
                    className="text-white bg-black py-3 px-5 rounded-md font-bold mx-auto block w-max text-[13px]"
                  >
                    {section.bannerwithbutton.buttonText || "Get in Touch"}
                  </NavLink>
                </div>
              )}

              {section.table && (
                <div className="my-4 overflow-x-auto">
                  <h3 className="text-lg font-bold mb-2">{section.table.title}</h3>
                  <table className="min-w-full border border-gray-300">
                    <thead className="bg-gray-100">
                      <tr>
                        {section.table.headers.map((header, idx) => (
                          <th key={idx} className="text-left px-4 py-2 border">
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {section.table.rows.map((row, idx) => (
                        <tr key={idx}>
                          {row.map((cell, cellIdx) => (
                            <td key={cellIdx} className="px-4 py-2 border">
                              {cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}


              {/* Call to Action */}
              {section.call_to_action && (

                <div className="mt-4 text-[16px] font-[400]" dangerouslySetInnerHTML={{ __html: section.call_to_action }}>
                </div>
              )}
            </div>
          ))}
          <div>
            <h2 className="text-lg font-semibold text-gray-600 ">
              What you can read next
            </h2>
            <BlogReccomendations />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsCard;
